<script setup>
import { onMounted } from "vue";
import { useQuizWordsStore } from "@/stores/storeQuizWords";
import { useGameTimers } from "@/composables/useGameTimers";
import BaseButtonUploadReceipt from "@/components/ui/BaseButtonUploadReceipt.vue";
import QuizWordsTimer from "@/components/quize/QuizWordsTimer.vue";

const storeQuizWords = useQuizWordsStore();
const { timerPoints } = useGameTimers();

onMounted(() => {
	storeQuizWords.progressGame();
})
</script>
<template>
	<div class="quiz-end-game quiz-padding">
		<div class="container">
			<h2 class="quiz-end-game__title game-title --mobile">Уровень {{ storeQuizWords.dataGame?.level_number || 1  }} пройден!</h2>
			<div class="quiz-end-game__container">
				<div class="quiz-end-game__block">
					<h2 class="quiz-end-game__title game-title ">Уровень {{ storeQuizWords.dataGame?.level_number || 1  }} пройден!</h2>
					<div class="quiz-end-game__scope">+ {{ storeQuizWords.dataGame?.points_awarded }}<svg width='40' height='40'><use href='#leaf'></use></svg></div>
					<div class="quiz-end-game__btns">
						<p class="quiz-end-game__subtitle">Чтобы начислить листочки в общий баланс и использовать их для призов — загрузите валидный чек</p>
						<QuizWordsTimer :count="storeQuizWords.gameProgress?.series?.points_earned " :time="timerPoints.remaining.value.hours + ':' + timerPoints.remaining.value.minutes"  />
						<div class="quiz-end-game__btns-footer">
							<button @click="storeQuizWords.continueGame()" class="btn">Продолжить</button>
							<BaseButtonUploadReceipt  class="quiz-end-game__btn">Загрузить чек</BaseButtonUploadReceipt>
						</div>
					</div>
				</div>
				<div class="quiz-end-game__box">
					<picture class="quiz-end-game__img">
						<source media="(max-width: 480px)" srcset="@/assets/img/games/start_words_mobile.webp" />
						<img class="full-img" width="549" height="549" src="@/assets/img/games/start_words.webp" alt="изображение" />
					</picture>
				</div>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.quiz-end-game {
	&__container {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 1rem;
		@media (max-width: vars.$mn) {
			flex-direction: column-reverse;
			gap: 2.4rem;
		}
	}

	&__block {
		width: fit-content;
		display: grid;
		gap: 3rem;
		justify-items: start;
		@media (max-width: vars.$mn) {
			gap: 2rem;
			justify-items: center;
		}
	}

	&__title {
		line-height: 100%;
		@media (max-width: vars.$mn) {
			display: none;
			text-align: center;
		}
		&.--mobile {
			display: none;
			@media (max-width: vars.$mn) {
				display: block;
				margin-bottom: 3rem;
			}
		}
	}

	&__scope {

		font-family: var(--second-family);
		font-weight: 700;
		font-size: 4.4rem;
		line-height: 110%;
		text-transform: uppercase;
		color: var(--text-accent-2-100);
		
		svg {
			width: 4rem;
			height: 4rem;
		}
	}

	&__subtitle {
		max-width: 62.2rem;
		@media (max-width: vars.$mn) {
			text-align: center;
		}
		@media (max-width: vars.$x480) {
			font-size: 1.6rem;
			line-height: 140%;
		}
	}
	&__btns {
		display: grid;
		gap: 2.4rem;
		@media (max-width: vars.$mn) {
			    justify-items: center;
		}
	}
	&__btn {
		width: fit-content;
		@media (max-width: vars.$mn) {
			width: 100%;
		}
	}

	&__box {
		@media (max-width: vars.$x480) {
			width: 100%;
		}
	}
	&__img {
		@extend .base-bg-light;
		display: block;
		border: 2.33px solid var(--border-accent-2-3);
		border-radius: 4rem;
		width: 54.9rem;
		height: 54.9rem;
		overflow: hidden;
		@media (max-width: vars.$x480) {
			height: 14.5rem;
			width: 100%;
			border-radius: 2.4rem;
		}
	}
	&__btns-footer {
		display: flex;
		align-items: center;
		gap: 2.4rem;
		@media (max-width: vars.$xx) {
			flex-direction: column;
		}
	}
}
.quiz-padding {
	padding: 4.3rem 0 7.4rem;
	@media (max-width: vars.$x480) {
		padding: 2.7rem 0 7.4rem;
	}
}
</style>
